import { TreeHeader } from "companion/routes/tasks/tree-header"
import { TreeSchedule } from "companion/routes/tasks/tree-schedule"

export function TreeItem({ item }) {
    return item.value ? <TreeHeader item={item} /> : <TreeSchedule item={item} />
}
